import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'
import Login from '@/components/Login'
import About from '@/components/About'
import Suggest from '@/components/Suggest'
import Detail from '@/components/Detail'
import Type from '@/components/Type'
import My from '@/components/My'
import Vs from '@/components/Vs'
import Search from '@/components/Search'
import Test from '@/components/Test'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/test',
      name: 'Test',
      component: Test
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
      meta: { keepAlive: true }
    },
    {
      path: '/vs/:type',
      name: 'Vs',
      component: Vs
    },
    {
      path: '/my',
      name: 'My',
      component: My
    },
    {
      path: '/type',
      name: 'Type',
      component: Type
    },
    {
      // 1代表最后一页面
      path: '/detail/:id/:isone',
      name: 'Detail',
      component: Detail
    },
    {
      path: '/suggest',
      name: 'Suggest',
      component: Suggest
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { keepAlive: true }
    }
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js